export default __webpack_public_path__ + "static/media/ic-add.8ff98476.svg";